export default __webpack_public_path__ + "static/media/8-min.46449a61.jpg";